import React from 'react';

export const DisplayPagination = React.memo(({ totalCount, current, count = 10 }) => {
  const last = totalCount > count * current ? count * current : totalCount;
  const first = (current - 1) * count + 1;
  return `Displayed ${first}-${last} out of ${totalCount}`;
});
